import { transformEmailPrivacy } from './emailPrivacyTransformer';
import { transformSslSecure } from './sslSecureTransformer';
import { transformMixedContent } from './mixedContentTransformer';

export { transformEmailPrivacy } from './emailPrivacyTransformer';
export { transformSslSecure } from './sslSecureTransformer';
export { transformMixedContent } from './mixedContentTransformer';

/**
 * Transforms all security-related criteria from WooRank API response
 * @param {Object} apiData - The full API response data
 * @returns {Object} - Transformed security section data for React components
 */
export const transformSecuritySection = (apiData = {}) => {
  const criteria = apiData?.criteria || {};

  const emailPrivacy = transformEmailPrivacy(criteria?.email_security);
  const sslSecure = transformSslSecure(criteria?.ssl_secured);
  const mixedContent = transformMixedContent(criteria?.mixed_content);

  const allResults = [emailPrivacy, sslSecure, mixedContent];
  const errorCount = allResults.filter((r) => r?.status === 'error').length || 0;
  const toImproveCount = allResults.filter((r) => r?.status === 'warning').length || 0;

  return {
    errorCount,
    toImproveCount,
    emailPrivacy,
    sslSecure,
    mixedContent,
  };
};

